import { delay, call, put } from "redux-saga/effects"
import moment from "moment"
import { get as getApi } from "api"
import { Creators as StaticAlertCreators } from "modules/static-alert/model"
import { log } from "helpers/logger"

const NB_MINUTES = 4 * 60

export function* saga() {
  // Don't run in dev
  if (window.CLIENT_VERSION) {
    while (true) {
      try {
        const serverVersion = yield call(getApi, "/api/client/version", true)

        if (serverVersion !== window.CLIENT_VERSION) {
          // set restart time
          const restartTime = moment().add(NB_MINUTES, "m")

          // set alert
          yield put(StaticAlertCreators.setNewVersion(restartTime))

          // check if we're after the restart time
          while (moment().isBefore(restartTime)) {
            // Wait a minute, check again
            yield delay(60 * 1000)
          }

          // force reload
          window.location.reload()
        }

        // Ping server every 10 minutes
        yield delay(10 * 60 * 1000)
      } catch (err) {
        log(err)
      }
    }
  }
}
